jQuery(function initResortPhotoGallery($) {

    if ( $(".swiper-container.swiper-resort-photo-gallery .swiper-slide").length > 1 ) {

        options = {
            direction: 'horizontal',
            loop: true,

            autoplay: {
                delay: 7000,
                disableOnInteraction: true,
            },

            keyboardControl: true,
            mousewheelControl: true,

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            }
        };

        var mySwiper = new Swiper('.swiper-container.swiper-resort-photo-gallery', options);
    }

});